import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import './Partners.css';

// Import des logos (inchangé)
import ametys from '../assets/AMETYS-02.png';
import datum from '../assets/DATUM ENGINEERING.png';
import ehtp from '../assets/EHTP.png';
import hexagon from '../assets/HEXAGON GEO-SURVEYS.png';
import inau from '../assets/INAU.png';
import onigt from '../assets/Logo Onigt.JPG';
import sindibad from '../assets/Logo_Sindibad_Final.webp';
import dansmamaison from '../assets/LOGO-DANSMAMAISON-VEC.webp';
import tnc from '../assets/Logo-TNC.webp';
import mazad from '../assets/MAZAD EXPERT.png';
import reaconsult from '../assets/REACONSULT.png';
import timlog from '../assets/TIMLOG.png';
import welearn from '../assets/WELEARN.jpg';

const partners = [
  { id: 1, img: ametys, name: "Ametys" },
  { id: 2, img: datum, name: "Datum Engineering" },
  { id: 3, img: ehtp, name: "EHTP" },
  { id: 4, img: hexagon, name: "Hexagon Geo-Surveys" },
  { id: 5, img: inau, name: "INAU" },
  { id: 6, img: onigt, name: "ONIGT" },
  { id: 7, img: sindibad, name: "Sindibad" },
  { id: 8, img: dansmamaison, name: "Dans Ma Maison" },
  { id: 9, img: tnc, name: "TNC" },
  { id: 10, img: mazad, name: "Mazad Expert" },
  { id: 11, img: reaconsult, name: "Reaconsult" },
  { id: 12, img: timlog, name: "Timlog" },
  { id: 13, img: welearn, name: "WeLearn" },
];

const Partners = () => {
  return (
    <section className="partners-section">
      <div className="container">
        
        {/* En-tête de section */}
        <div className="section-header">
          <h5>NOS RÉFÉRENCES</h5>
          <h2>ILS NOUS FONT <span>CONFIANCE</span></h2>
        </div>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={50}
          slidesPerView={5}
          loop={true}
          speed={2000}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 2, spaceBetween: 20 },
            640: { slidesPerView: 3, spaceBetween: 30 },
            1024: { slidesPerView: 5, spaceBetween: 50 },
          }}
          className="partners-swiper"
        >
          {partners.map((partner) => (
            <SwiperSlide key={partner.id}>
              <div className="partner-logo-box">
                <img src={partner.img} alt={partner.name} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default Partners;